import { X } from "lucide-react";
import { IconButton } from "@doculegis/shared";
import { cn } from "@/lib/utils";
import type { ReviewRow, RiskLevel } from "@/types";

interface AttachedSectionChipProps {
  row: ReviewRow;
  /** When set, shows remove button */
  onRemove?: () => void;
  compact?: boolean;
}

const riskBorderBg: Record<RiskLevel, string> = {
  acceptable: "border-green-500/40 bg-green-500/10",
  "acceptable-clarify": "border-yellow-500/40 bg-yellow-500/10",
  "not-acceptable": "border-red-500/40 bg-red-500/10",
};

export function AttachedSectionChip({ row, onRemove, compact }: AttachedSectionChipProps) {
  const palette = riskBorderBg[row.riskLevel] ?? "border-white/15 bg-white/5";

  return (
    <span
      className={cn(
        "inline-flex max-w-full items-center gap-1.5 rounded-lg border px-2 py-1 text-left text-xs",
        palette,
        compact ? "py-0.5" : undefined,
      )}
    >
      <span className="min-w-0 truncate font-medium text-[#101828] dark:text-white">
        {row.section}
      </span>
      <span className="shrink-0 text-[10px] text-[#576274] dark:text-slate-400">p.{row.pageNumber}</span>
      {onRemove ? (
        <IconButton
          type="button"
          size="xs"
          variant="destructive"
          onClick={onRemove}
          className="ml-0.5 shrink-0"
          aria-label={`Remove ${row.section}`}
        >
          <X className="h-3 w-3" />
        </IconButton>
      ) : null}
    </span>
  );
}
